import { createFileRoute } from '@tanstack/react-router'

import { ExpenseDetail } from '@/components/expenses/expense-detail'
import { RETURN_SHAPE } from '@/lib/return-to'
import { readSearch } from '@/lib/search-params'

/** Fiche d'une note de frais, ouverte par son numéro (« NF-2026-0001 ») ou son identifiant (lot 15, #212). */
export const Route = createFileRoute('/_app/frais/$expenseNumber')({
  validateSearch: (search: Record<string, unknown>) => readSearch(RETURN_SHAPE, search),
  component: ExpenseDetailPage,
})

function ExpenseDetailPage() {
  const { expenseNumber } = Route.useParams()
  return <ExpenseDetail expenseNumber={expenseNumber} />
}
